import style from "./Demo.module.css"

export const Demo = () => <div className={style.wrapper}>demo</div>
